// finding_edit.js

$(document).ready(function () {
    initForms();
    initButtons();
});

function initForms() {
    // Enable "diry form" checking on the form
    $('form').areYouSure();

    // update the list of available theme <options> when strategy option changes
    $('select#strategy-select').on('change', function() {
    	var strategy_id = $(this).val();
    	// get the list of themes for the selected strategy
    	$.get(BASE_URL + '/datavis/data/themes/' + strategy_id, function(themes) {
    		var target = $('select#themes-select').empty();
    		$('<option>').appendTo(target); // for the placeholder
    		themes.forEach(function(theme) {
    			var option = $('<option>', {
    				value: theme.id,
    				text: theme.name
    			}).appendTo(target);
    		});
    		// rebuild the theme <select> as a select2
        	var placeholder = target.attr('placeholder'); // optionally include a placeholder attribute
        	var clear = target.attr('allowclear');        // optionally include clear=true to allow the clear button
        	var search = target.attr('allowsearch');      // optionally allow search within the select2
        	target.select2({
            	placeholder: placeholder,
	            minimumResultsForSearch: search ? 0 : Infinity,
	            allowClear: clear
	        });
    	});
    });

    $('form').on('submit', function() {
        // when Researchers interact with this form, all form fields are disabled
        // because disabled form elements do not get submitted, this leads to errors in the view when it tries to set attributes 
        // wrap this in a form_disabled in an attempt to not make this so global
        // though, at the time of writing, we truly do simply disable everything
        if (FORM_DISABLED) {
            $('select').prop('disabled',false);
            $('textarea').prop('disabled',false);
        }
    });
}

function initButtons() {
    // only enable the save button when the form is dirty
    // this helps to prevent an empty submission, which would "unpublish" the finding for no reason
    $('form#editform').on('dirty.areYouSure', function() {
        // Enable save button only as the form is dirty.
        $(this).find('button#save-button').removeAttr('disabled');
    });
    $('form#editform').on('clean.areYouSure', function() {
        // Form is clean so nothing to save - disable the save button.
        $(this).find('button#save-button').attr('disabled', 'disabled');
    });

    // toggle the watch button, and trigger an Ajax call to turn watching on/off for this finding
    $('div.watch-wrapper').on('click', function() {
        var target = $(this);
        var params = {
            watching: target.data().watching,
            finding_id: target.data().findingId,
            csrfmiddlewaretoken: CRSFTOKEN
        }
        var url = BASE_URL + '/administration/finding/watch/';
        console.log(url);
        $.post( url, params, function(response) {
            if (response.indexOf('ERROR') > -1) {
                alert(response);
            } else {
                // Sucess: swap out the buttons
                // can't use toggle, 'cause we need display:flex
                var divs = target.find('div.watch-inner');
                divs.each(function() {
                    var div = $(this)
                    if (div.is(':visible')) { 
                        div.hide(); 
                    } else {
                        div.css({'display': 'flex'});
                    }
                })
            }
        });
    });
}